import PageBackBar from "@/components/PageBackBar";
import Gallery from "@/components/Gallery";
import { useSite } from "@/Layout";

export default function PhotosPage() {
  const { media } = useSite();
  // Hard filter — /photos is photographs only.
  const photos = (media || []).filter((m) => m.type !== "video");
  return (
    <div data-testid="photos-page">
      <PageBackBar testId="photos-back-bar" />
      <Gallery media={photos} />
    </div>
  );
}
